import CampaignV2ActionType from 'actions/campaignV2/campaignV2ActionType';

const initialState = {
  campaigns: {},
  campaign: {},
  campaignConnectedSourceTypes: [],
  createdCampaignId: null,
  generalConfigEndedStatus: false,
  participationGroup: {},
  participationGroups: null,
  participationGroupEndedStatus: false,
  freeBetBonus: {},
  freeSpinBonus: {},
  combinedBonus: {},
  specialBonus: {},
  bonusEndedStatus: false,
  bonuses: null,
  triggerConditions: null,
  triggerCondition: {},
  triggerConditionEndedStatus: false,
  bonusContents: null,
  bonusContent: {},
  bonusContentEndedStatus: false,
  campaignContents: null,
  campaignContent: {},
  campaignContentEndedStatus: false,
  offersContents: null,
  offersContent: {},
  offersContentEndedStatus: false,
  units: null,
  unit: {},
  unitEndedStatus: false,
  publishEndedStatus: false,

  freeBetBonuses: {},
  spinBonuses: {},
  wagerBonuses: {},
  specialBonuses: {},
  crossPlatformCampaigns: {},
  crossPlatformCampaign: {},
  crossPlatformCampaignFreeBetBonus: {},
  crossPlatformCampaignFreeSpinBonus: {},
  crossPlatformCampaignCombinedBonus: {},
  crossPlatformCampaignSpecialBonus: {},
  crossPlatformCampaignBonuses: null,
  crossPlatformCampaignBonusContents: null,
  crossPlatformCampaignBonusContent: {},
  crossPlatformCampaignUnits: null,
  crossPlatformCampaignUnit: {},
  crossPlatformCampaignStatistics: {},
  playerFreeBetBonuses: {},
  playerSpinBonuses: {},
  playerCombinedBonuses: {},
  playerSpecialBonuses: {},
  campaignV2BonusStatistics: {},
  playerUnits: {},
  unitsParticipationDetails: null,
};

const campaignV2Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case CampaignV2ActionType.SAVE_CAMPAIGNS_V2:
    return {
      ...state,
      campaigns: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGNS_V2:
    return {
      ...state,
      campaigns: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2:
    return {
      ...state,
      campaign: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2:
    return {
      ...state,
      campaign: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_CONNECTED_SOURCE_TYPES:
    return {
      ...state,
      campaignConnectedSourceTypes: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_CONNECTED_SOURCE_TYPES:
    return {
      ...state,
      campaignConnectedSourceTypes: [],
    };
  case CampaignV2ActionType.SAVE_CREATED_CAMPAIGN_V2_ID:
    return {
      ...state,
      createdCampaignId: payload.id,
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_GENERAL_CONFIG_ENDED_STATUS:
    return {
      ...state,
      generalConfigEndedStatus: payload.status,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_PARTICIPATION_GROUP:
    return {
      ...state,
      participationGroup: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_PARTICIPATION_GROUP:
    return {
      ...state,
      participationGroup: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_PARTICIPATION_GROUPS:
    return {
      ...state,
      participationGroups: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_PARTICIPATION_GROUPS:
    return {
      ...state,
      participationGroups: null,
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_PARTICIPATION_GROUP_ENDED_STATUS:
    return {
      ...state,
      participationGroupEndedStatus: payload.status,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_FREE_BET_BONUS:
    return {
      ...state,
      freeBetBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_FREE_BET_BONUS:
    return {
      ...state,
      freeBetBonus: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_FREE_SPIN_BONUS:
    return {
      ...state,
      freeSpinBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_FREE_SPIN_BONUS:
    return {
      ...state,
      freeSpinBonus: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_COMBINED_BONUS:
    return {
      ...state,
      combinedBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_COMBINED_BONUS:
    return {
      ...state,
      combinedBonus: {},
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_BONUS_ENDED_STATUS:
    return {
      ...state,
      bonusEndedStatus: payload.status,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_SPECIAL_BONUS:
    return {
      ...state,
      specialBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_SPECIAL_BONUS:
    return {
      ...state,
      specialBonus: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_BONUSES:
    return {
      ...state,
      bonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_BONUSES:
    return {
      ...state,
      bonuses: null,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_TRIGGER_CONDITIONS:
    return {
      ...state,
      triggerConditions: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_TRIGGER_CONDITIONS:
    return {
      ...state,
      triggerConditions: null,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_TRIGGER_CONDITION:
    return {
      ...state,
      triggerCondition: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_TRIGGER_CONDITION:
    return {
      ...state,
      triggerCondition: {},
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_TRIGGER_CONDITION_ENDED_STATUS: {
    return {
      ...state,
      triggerConditionEndedStatus: payload.status,
    };
  }
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_BONUS_CONTENTS:
    return {
      ...state,
      bonusContents: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_BONUS_CONTENTS:
    return {
      ...state,
      bonusContents: null,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_BONUS_CONTENT:
    return {
      ...state,
      bonusContent: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_BONUS_CONTENT:
    return {
      ...state,
      bonusContent: {},
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_BONUS_CONTENT_ENDED_STATUS: {
    return {
      ...state,
      bonusContentEndedStatus: payload.status,
    };
  }
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_CAMPAIGN_CONTENTS:
    return {
      ...state,
      campaignContents: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_CAMPAIGN_CONTENTS:
    return {
      ...state,
      campaignContents: null,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_CAMPAIGN_CONTENT:
    return {
      ...state,
      campaignContent: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_CAMPAIGN_CONTENT:
    return {
      ...state,
      campaignContent: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_OFFERS_CONTENTS:
    return {
      ...state,
      offersContents: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_OFFERS_CONTENTS:
    return {
      ...state,
      offersContents: null,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_OFFERS_CONTENT:
    return {
      ...state,
      offersContent: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_OFFERS_CONTENT:
    return {
      ...state,
      offersContent: {},
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_OFFERS_CONTENT_ENDED_STATUS: {
    return {
      ...state,
      offersContentEndedStatus: payload.status,
    };
  }
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_CAMPAIGN_CONTENT_ENDED_STATUS: {
    return {
      ...state,
      campaignContentEndedStatus: payload.status,
    };
  }
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_UNITS:
    return {
      ...state,
      units: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_UNITS:
    return {
      ...state,
      units: null,
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_UNIT:
    return {
      ...state,
      unit: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_UNIT:
    return {
      ...state,
      unit: {},
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_UNIT_ENDED_STATUS:
    return {
      ...state,
      unitEndedStatus: payload.status,
    };
  case CampaignV2ActionType.CHANGE_CAMPAIGN_V2_PUBLISH_ENDED_STATUS: {
    return {
      ...state,
      publishEndedStatus: payload.status,
    };
  }
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_FREE_BET_BONUSES:
    return {
      ...state,
      freeBetBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_FREE_BET_BONUSES:
    return {
      ...state,
      freeBetBonuses: {},
    };

  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_SPIN_BONUSES:
    return {
      ...state,
      spinBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_SPIN_BONUSES:
    return {
      ...state,
      spinBonuses: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_WAGER_BONUSES:
    return {
      ...state,
      wagerBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_WAGER_BONUSES:
    return {
      ...state,
      wagerBonuses: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_SPECIAL_BONUSES:
    return {
      ...state,
      specialBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_SPECIAL_BONUSES:
    return {
      ...state,
      specialBonuses: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGNS_V2:
    return {
      ...state,
      crossPlatformCampaigns: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGNS_V2:
    return {
      ...state,
      crossPlatformCampaigns: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2:
    return {
      ...state,
      crossPlatformCampaign: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2:
    return {
      ...state,
      crossPlatformCampaign: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_FREE_BET_BONUS:
    return {
      ...state,
      crossPlatformCampaignFreeBetBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_FREE_BET_BONUS:
    return {
      ...state,
      crossPlatformCampaignFreeBetBonus: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_FREE_SPIN_BONUS:
    return {
      ...state,
      crossPlatformCampaignFreeSpinBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_FREE_SPIN_BONUS:
    return {
      ...state,
      crossPlatformCampaignFreeSpinBonus: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_COMBINED_BONUS:
    return {
      ...state,
      crossPlatformCampaignCombinedBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_COMBINED_BONUS:
    return {
      ...state,
      crossPlatformCampaignCombinedBonus: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_SPECIAL_BONUS:
    return {
      ...state,
      crossPlatformCampaignSpecialBonus: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_SPECIAL_BONUS:
    return {
      ...state,
      crossPlatformCampaignSpecialBonus: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_BONUSES:
    return {
      ...state,
      crossPlatformCampaignBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_BONUSES:
    return {
      ...state,
      crossPlatformCampaignBonuses: null,
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_BONUS_CONTENTS:
    return {
      ...state,
      crossPlatformCampaignBonusContents: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_BONUS_CONTENTS:
    return {
      ...state,
      crossPlatformCampaignBonusContents: null,
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_BONUS_CONTENT:
    return {
      ...state,
      crossPlatformCampaignBonusContent: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_BONUS_CONTENT:
    return {
      ...state,
      crossPlatformCampaignBonusContent: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_UNITS:
    return {
      ...state,
      crossPlatformCampaignUnits: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_UNITS:
    return {
      ...state,
      crossPlatformCampaignUnits: null,
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_UNIT:
    return {
      ...state,
      crossPlatformCampaignUnit: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_UNIT:
    return {
      ...state,
      crossPlatformCampaignUnit: {},
    };
  case CampaignV2ActionType.SAVE_CROSS_PLATFORM_CAMPAIGN_V2_STATISTICS:
    return {
      ...state,
      crossPlatformCampaignStatistics: payload.data,
    };
  case CampaignV2ActionType.RESET_CROSS_PLATFORM_CAMPAIGN_V2_STATISTICS:
    return {
      ...state,
      crossPlatformCampaignStatistics: {},
    };
  case CampaignV2ActionType.SAVE_PLAYER_FREE_BET_BONUSES_V2:
    return {
      ...state,
      playerFreeBetBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_PLAYER_FREE_BET_BONUSES_V2:
    return {
      ...state,
      playerFreeBetBonuses: {},
    };
  case CampaignV2ActionType.SAVE_PLAYER_SPIN_BONUSES_V2:
    return {
      ...state,
      playerSpinBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_PLAYER_SPIN_BONUSES_V2:
    return {
      ...state,
      playerSpinBonuses: {},
    };
  case CampaignV2ActionType.SAVE_PLAYER_COMBINED_BONUSES_V2:
    return {
      ...state,
      playerCombinedBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_PLAYER_COMBINED_BONUSES_V2:
    return {
      ...state,
      playerCombinedBonuses: {},
    };
  case CampaignV2ActionType.SAVE_PLAYER_SPECIAL_BONUSES_V2:
    return {
      ...state,
      playerSpecialBonuses: payload.data,
    };
  case CampaignV2ActionType.RESET_PLAYER_SPECIAL_BONUSES_V2:
    return {
      ...state,
      playerSpecialBonuses: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_V2_BONUS_STATISTICS:
    return {
      ...state,
      campaignV2BonusStatistics: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_V2_BONUS_STATISTICS:
    return {
      ...state,
      campaignV2BonusStatistics: {},
    };
  case CampaignV2ActionType.SAVE_PLAYER_CAMPAIGN_V2_UNITS:
    return {
      ...state,
      playerUnits: payload.data,
    };
  case CampaignV2ActionType.RESET_PLAYER_CAMPAIGN_V2_UNITS:
    return {
      ...state,
      playerUnits: {},
    };
  case CampaignV2ActionType.SAVE_CAMPAIGN_UNITS_PARTICIPATION_DETAILS:
    return {
      ...state,
      unitsParticipationDetails: payload.data,
    };
  case CampaignV2ActionType.RESET_CAMPAIGN_UNITS_PARTICIPATION_DETAILS:
    return {
      ...state,
      unitsParticipationDetails: null,
    };
  default:
    return state;
  }
};

export default campaignV2Reducer;
